import React from "react"
import PropTypes from "prop-types"

// component
import {Accordeon, Help} from "../../../controls";

function Features({title, items, text, showInlineHelp, hideTitle}) {
  
  const lis = items.map(f => {
    let help = null
    if(f.info && showInlineHelp) {
      help = <><span> </span><Help title={f.info.title}>{f.info.text}</Help></> 
    }
    return <li key={f.key}>{f.text}{help}</li>
  })

  let explanation = null
  if(text && text.trim().length > 0) {
    explanation = <p>{text.trim()}</p>
  }

  if(hideTitle) {
    return (
      <div className="features">
        {explanation}
        <ul>
          {lis}
        </ul>
      </div>
    )
  }
  else {
    return (
      <Accordeon title={title}>
        {explanation}
        <ul>
          {lis}
        </ul>
      </Accordeon>
    )
  }
}

Features.propTypes = {
  showInlineHelp:PropTypes.bool
}
Features.defaultProps = {
  showInlineHelp:true
}

export default Features